import { ProductName } from '../types';

const urlProductPrefixActiveProductNameMap: Record<string, ProductName | undefined> = {
  pm: 'programmableMedia',
  console: 'digitalAssetManagement',
  settings: 'accountSettings',
  video: 'video',
  mediaflows: 'mediaFlows',
};

export const detectActiveProduct = (pageUrl: string) => {
  const { pathname } = new URL(pageUrl);

  const urlProductPrefix = pathname.split('/')[1];
  const activeProductName = urlProductPrefixActiveProductNameMap[urlProductPrefix];

  if (activeProductName) {
    return { kind: 'success' as const, activeProductName };
  }

  return { kind: 'error' as const };
};
